import styles from '../style.module.scss';
import moment from 'moment';
import api from 'helpers/api';
import HasPermission from 'helpers/permissions/HasPermission';

const ChangeLogList = ({ refresh, changelog, setIsViewing, setIsEditing, setIsCreatingNew, userRole, cardsRef }) => {

    const deleteLog = async (id) => {
        refresh()
        try {
            await api.delete(`/changelog/${id}`);
        } catch (e) {

        } finally {
            setIsEditing(null)
            refresh()
        }
    }

    return (
        <>
            { changelog.map((log, i) => {
                return (
                    <div key={ i } logId={ log.id } ref={ el => cardsRef.current[ i ] = el } className={ styles.logCard }>
                        <div className='d-flex align-items-center' style={ { gap: '10px' } }>
                            <span>{ moment(log.created_at).format('MMMM DD, YYYY') }</span>
                            { userRole === 5 && !log.published && <span style={ { color: 'red' } }>Not Published</span> }
                            { userRole === 5 && <div className='d-flex align-items-center' style={ {
                                marginLeft: 'auto',
                                gap: '10px'
                            } }>
                                <HasPermission permission="changelog.edit">
                                    <button onClick={ (e) => {
                                        setIsEditing(log)
                                        setIsCreatingNew(false)
                                    } } className='link-button button-small p-0'>Edit</button>
                                </HasPermission>

                                /

                                <HasPermission permission="changelog.edit"><button onClick={ (e) => {
                                    deleteLog(log.id)
                                } } className='link-button button-small p-0'>Delete</button></HasPermission>

                            </div> }
                        </div>
                        <a href="#" onClick={ (e) => {
                            e.preventDefault();
                            setIsViewing(log)
                        } }><h3>{ log.title }</h3></a>
                        <div className={ styles.logContent } dangerouslySetInnerHTML={ { __html: log.content } }>
                        </div>
                    </div>
                )
            }) }
        </>
    )
}

export default ChangeLogList;